// import React, { useEffect, useState } from "react";
// import axiosInstance from "../HSAxios";
// import Cookies from "js-cookie";
// import { useNavigate } from "react-router";
// import {
//   Spinner,
//   Card,
//   Form,
//   Button,
//   Dropdown,
//   DropdownToggle,
//   DropdownMenu,
//   DropdownItem,
// } from "react-bootstrap";
// import PaymentStatusModal from "./PaymentStatusModal";
// const UpdateProfile = ({ loggedIn, setLoggedIn }) => {
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [selectedItem, setSelectedItem] = useState("Select an option");

//   const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
//   const navigate = useNavigate();
//   const currentDate = new Date();
//   const year = currentDate.getFullYear();
//   const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Adding 1 to month since it's zero-based
//   const day = String(currentDate.getDate()).padStart(2, "0");
//   const formattedDate = `${year}-${month}-${day}`;
//   const [owner, setOwner] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [btnLoading, setBtnLoading] = useState(false);
//   const [title, setTitle] = useState(null);
//   const [btnTitle, setBtnTitle] = useState(null);
//   const [msg, setMsg] = useState(null);
//   const [isSuccess, setIsSuccess] = useState(false);
//   const [show, setShow] = useState(false);
//   useEffect(() => {
//     const token = Cookies.get("token");
//     if (!token) {
//       navigate("/", {});
//     }
//     if (token) {
//       setLoggedIn(true);
//       axiosInstance.get("api/hostel/owner").then((resposne) => {
//         if (resposne.status) {
//           console.log(resposne.data[0]);
//           if (false && resposne.data[0].gender && resposne.data[0].name) {
//             navigate("/", {});
//           } else {
//             setOwner((prev) => ({
//               ...prev,
//               phone_number: resposne.data[0].phone_number,
//             }));
//           }

//           setLoading(false);
//         }
//       });
//     }
//   }, []);
//   console.log(owner);
//   const handleChange = (key, e) => {
//     if (key === "id_proof_type") {
//       setOwner(() => ({
//         ...owner,
//         [key]: e,
//       }));
//     } else {
//       setOwner(() => ({
//         ...owner,
//         [key]: e.target.value,
//       }));
//     }
//   };
//   const handleUpdate = () => {
//     console.log("will handle update later");

//     setBtnLoading(true);
//     // delete owner.phone_number;
//     console.log(owner);
//     axiosInstance
//       .post("api/hostel/owner/create", owner)
//       .then((response) => {
//         console.log(response);

//         setMsg(response.result);
//         setTitle("Registration Successful");
//         setBtnTitle(null);
//         setIsSuccess(true);
//         setShow(true);
//       })
//       .catch((error) => {
//         console.log(error);
//         setMsg("Some Error Occurred!");
//         setTitle("Registration Error");
//         setBtnTitle(null);
//         setIsSuccess(false);
//         setShow(true);
//       })
//       .finally(() => {
//         setBtnLoading(false);
//       });
//   };
//   console.log(owner);

//   return (
//     <div>
//       {loading && (
//         <div className="mt-5 h-80vh w-100vw d-flex align-items-center flex-column">
//           {" "}
//           <Spinner
//             animation="border"
//             role="status"
//             className="text-primary mt-5 fw-bold"
//           ></Spinner>
//           <br></br>
//           <span className="text-black">Loading your Profile...</span>
//         </div>
//       )}

//       {!loading && (
//         <div>
//           <PaymentStatusModal
//             show={show}
//             title={title}
//             msg={msg}
//             btnTitle={btnTitle}
//             isSuccess={isSuccess}
//             onClose={() => setShow(false)}
//           />
//           <Card
//             className="container mt-3 justify-content-md-center"
//             style={{ width: "310px", marginTop: "100px" }}
//           >
//             <Card.Body>
//               <div className="text-center">
//                 <img
//                   className="mt-3  pb-4 rounded-circle img-fluid"
//                   src={`${process.env.PUBLIC_URL}/rb_4707.png`}
//                   style={{ width: "100px" }}
//                 />
//               </div>
//               <Form className="text-start">
//                 <Form.Group className="mt-2">
//                   <Form.Label className="fw-bold">Name</Form.Label>
//                   <Form.Control
//                     type="text"
//                     value={owner.name || ""}
//                     onChange={(e) => handleChange("name", e)}
//                   />
//                   {/* {error.name && <p className="text-danger">{error.name}</p>} */}
//                 </Form.Group>
//                 <Form.Group className="mt-3">
//                   <Form.Label className="fw-bold"> Email</Form.Label>
//                   <Form.Control
//                     type="text"
//                     onChange={(e) => handleChange("email_id", e)}
//                     value={owner.email_id || ""}
//                   />
//                 </Form.Group>

//                 <Form.Group className="mt-3">
//                   <Form.Label className="fw-bold">Phone Number</Form.Label>
//                   <Form.Control
//                     type="text"
//                     disabled
//                     value={owner.phone_number || ""}
//                   />
//                 </Form.Group>
//                 <Form.Group className="mt-3">
//                   <Form.Label className="fw-bold"> Address</Form.Label>
//                   <Form.Control
//                     type="text"
//                     onChange={(e) => handleChange("address", e)}
//                     value={owner.address || ""}
//                   />
//                 </Form.Group>
//                 {/* <Form.Group className="mt-3">
//                   <Form.Label className="fw-bold"> Date of Birth</Form.Label>
//                   <Form.Control
//                     type="text"
//                     onChange={(e) => handleChange("date_of_birth", e)}
//                     value={owner.date_of_birth || ""}
//                   />
//                 </Form.Group> */}
//                 <Form.Label className="mt-3 fw-bold">Select Date</Form.Label>
//                 <Form.Control
//                   size="lg"
//                   type="date"
//                   name="select date"
//                   value={owner.date_of_birth || ""}
//                   max={formattedDate}
//                   id="select date"
//                   className="mt-1"
//                   onChange={(e) => handleChange("date_of_birth", e)}
//                 />
//                 <Form.Group className="mt-3">
//                   <Form.Label className="fw-bold"> Gender</Form.Label>
//                   <Form.Control
//                     type="text"
//                     onChange={(e) => handleChange("gender", e)}
//                     value={owner.gender || ""}
//                   />
//                 </Form.Group>
//                 <Form.Group className="mt-3">
//                   {/* <Form.Label className="fw-bold"> Select ID</Form.Label>
//                   <Form.Control
//                     type="text"
//                     onChange={(e) => handleChange("id_proof_type", e)}
//                     value={owner.id_proof_type || ""}
//                   /> */}
//                   <Form.Group className="mt-3">
//                     <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
//                       <DropdownToggle caret>
//                         {owner.id_proof_type || "Select ID Type"}
//                       </DropdownToggle>
//                       <DropdownMenu>
//                         <DropdownItem
//                           onClick={(e) =>
//                             handleChange("id_proof_type", "AADHAR CARD")
//                           }
//                         >
//                           AADHAR CARD
//                         </DropdownItem>
//                         <DropdownItem
//                           onClick={() =>
//                             handleChange("id_proof_type", "PAN CARD")
//                           }
//                         >
//                           PAN CARD
//                         </DropdownItem>
//                         <DropdownItem
//                           onClick={() =>
//                             handleChange("id_proof_type", "LICENSE")
//                           }
//                         >
//                           LICENSE
//                         </DropdownItem>
//                       </DropdownMenu>
//                     </Dropdown>
//                   </Form.Group>
//                   <Form.Label className="fw-bold mt-3">ID Number</Form.Label>
//                   <Form.Control
//                     type="text"
//                     onChange={(e) => handleChange("id_proof_number", e)}
//                     value={owner.id_proof_number || ""}
//                   />
//                 </Form.Group>

//                 <Button
//                   style={{ backgroundColor: "#004AAD" }}
//                   className="mt-2"
//                   type="button"
//                   onClick={handleUpdate}
//                 >
//                   {btnLoading ? "Updating ..." : "Update"}
//                 </Button>
//               </Form>
//             </Card.Body>
//           </Card>
//         </div>
//       )}
//     </div>
//   );
// };

// export default UpdateProfile;

import React, { useEffect, useState } from "react";
import axiosInstance from "../HSAxios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router";
import {
  Spinner,
  Card,
  Form,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "react-bootstrap";
import PaymentStatusModal from "./PaymentStatusModal";

const UpdateProfile = ({ loggedIn, setLoggedIn }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("Select an option");

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const navigate = useNavigate();
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;
  const [owner, setOwner] = useState({});
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [title, setTitle] = useState(null);
  const [btnTitle, setBtnTitle] = useState(null);
  const [msg, setMsg] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      navigate("/", {});
    }
    if (token) {
      setLoggedIn(true);
      axiosInstance.get("api/hostel/owner").then((response) => {
        if (response.status) {
          setOwner((prev) => ({
            ...prev,
            phone_number: response.data[0].phone_number,
          }));
          setLoading(false);
        }
      });
    }
  }, []);

  const validate = () => {
    const newErrors = {};
    if (!owner.name || owner.name.trim() === "") {
      newErrors.name = "Name is required.";
    }
    if (
      !owner.email_id ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(owner.email_id.trim())
    ) {
      newErrors.email_id = "Valid email is required.";
    }
    if (!owner.address || owner.address.trim() === "") {
      newErrors.address = "Address is required.";
    }
    if (!owner.date_of_birth) {
      newErrors.date_of_birth = "Date of birth is required.";
    }
    if (!owner.gender || owner.gender.trim() === "") {
      newErrors.gender = "Gender is required.";
    }
    if (!owner.id_proof_type) {
      newErrors.id_proof_type = "ID type is required.";
    }
    if (!owner.id_proof_number || owner.id_proof_number.trim() === "") {
      newErrors.id_proof_number = "ID number is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (key, e) => {
    if (key === "id_proof_type") {
      setOwner((prev) => ({
        ...prev,
        [key]: e,
      }));
    } else {
      setOwner((prev) => ({
        ...prev,
        [key]: e.target.value,
      }));
    }
  };

  const handleUpdate = () => {
    if (!validate()) {
      return;
    }
    setBtnLoading(true);
    axiosInstance
      .post("api/hostel/owner/create", owner)
      .then((response) => {
        setMsg(`${response.result}. Redirecting to home...`);
        setTitle("Registration Successful");
        setBtnTitle(null);
        setIsSuccess(true);
        setShow(true);
        setTimeout(() => navigate("/", {}), 3000);
      })
      .catch((error) => {
        setMsg("Some Error Occurred!");
        setTitle("Registration Error");
        setBtnTitle(null);
        setIsSuccess(false);
        setShow(true);
      })
      .finally(() => {
        setBtnLoading(false);
      });
  };

  return (
    <div>
      {loading && (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "70vh" }}>
          <Spinner
            animation="border"
            role="status"
            style={{
              width: "3rem",
              height: "3rem",
              borderWidth: "4px",
              borderColor: "#8B0000",
              borderRightColor: "transparent",
            }}
          />
          <p className="mt-4 fw-semibold" style={{ color: "#333", fontSize: "18px" }}>
            Loading your profile...
          </p>
        </div>
      )}

      {!loading && (
        <div>
          <PaymentStatusModal
            show={show}
            title={title}
            msg={msg}
            btnTitle={btnTitle}
            isSuccess={isSuccess}
            onClose={() => setShow(false)}
          />
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
            <Card
              className="border-0 shadow-lg"
              style={{
                width: "100%",
                maxWidth: "500px",
                borderRadius: "20px",
                boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 50px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 40px rgba(0,0,0,0.1)";
              }}
            >
              <Card.Body className="p-4">
                <div className="text-center mb-4">
                  <img
                    className="pb-4 rounded-circle img-fluid"
                    src={`${process.env.PUBLIC_URL}/rb_4707.png`}
                    style={{
                      width: "120px",
                      height: "120px",
                      objectFit: "cover",
                      border: "4px solid #e0e0e0",
                    }}
                    alt="Profile"
                  />
                  <h4 className="fw-bold mt-3" style={{ color: "#760B0B" }}>Update Profile</h4>
                </div>
                <Form className="text-start">
                  <Form.Group className="mt-3">
                    <Form.Label className="fw-semibold mb-2" style={{ color: "#333" }}>Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={owner.name || ""}
                      onChange={(e) => handleChange("name", e)}
                      className="py-2"
                      style={{
                        borderRadius: "10px",
                        border: "2px solid #e0e0e0",
                        transition: "border-color 0.3s ease",
                      }}
                      onFocus={(e) => e.target.style.borderColor = "#8B0000"}
                      onBlur={(e) => e.target.style.borderColor = "#e0e0e0"}
                    />
                    {errors.name && <p className="text-danger mt-2">{errors.name}</p>}
                  </Form.Group>
                <Form.Group className="mt-3">
                  <Form.Label className="fw-bold">Email</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleChange("email_id", e)}
                    value={owner.email_id || ""}
                  />
                  {errors.email_id && (
                    <p className="text-danger">{errors.email_id}</p>
                  )}
                </Form.Group>
                <Form.Group className="mt-3">
                  <Form.Label className="fw-bold">Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    disabled
                    value={owner.phone_number || ""}
                  />
                </Form.Group>
                <Form.Group className="mt-3">
                  <Form.Label className="fw-bold">Address</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleChange("address", e)}
                    value={owner.address || ""}
                  />
                  {errors.address && (
                    <p className="text-danger">{errors.address}</p>
                  )}
                </Form.Group>
                <Form.Label className="mt-3 fw-bold">Select Date</Form.Label>
                <Form.Control
                  size="lg"
                  type="date"
                  name="select date"
                  value={owner.date_of_birth || ""}
                  max={formattedDate}
                  id="select date"
                  className="mt-1"
                  onChange={(e) => handleChange("date_of_birth", e)}
                />
                {errors.date_of_birth && (
                  <p className="text-danger">{errors.date_of_birth}</p>
                )}
                <Form.Group className="mt-3">
                  <Form.Label className="fw-bold">Gender</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => handleChange("gender", e)}
                    value={owner.gender || ""}
                  />
                  {errors.gender && (
                    <p className="text-danger">{errors.gender}</p>
                  )}
                </Form.Group>
                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                  <DropdownToggle caret>
                    {owner.id_proof_type || "Select ID Type"}
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      onClick={() =>
                        handleChange("id_proof_type", "AADHAR CARD")
                      }
                    >
                      AADHAR CARD
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => handleChange("id_proof_type", "PAN CARD")}
                    >
                      PAN CARD
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => handleChange("id_proof_type", "LICENSE")}
                    >
                      LICENSE
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                {errors.id_proof_type && (
                  <p className="text-danger">{errors.id_proof_type}</p>
                )}
                <Form.Label className="fw-bold mt-3">ID Number</Form.Label>
                <Form.Control
                  type="text"
                  onChange={(e) => handleChange("id_proof_number", e)}
                  value={owner.id_proof_number || ""}
                />
                {errors.id_proof_number && (
                  <p className="text-danger">{errors.id_proof_number}</p>
                )}
                <Button
                  style={{
                    backgroundColor: "#004AAD",
                    borderColor: "#004AAD",
                    width: "100%",
                    borderRadius: "10px",
                    padding: "12px",
                    fontSize: "16px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 15px rgba(0, 74, 173, 0.3)",
                  }}
                  className="mt-4 fw-semibold"
                  type="button"
                  onClick={handleUpdate}
                  disabled={btnLoading}
                  onMouseEnter={(e) => {
                    if (!btnLoading) {
                      e.target.style.backgroundColor = "#0056b3";
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow = "0 6px 20px rgba(0, 74, 173, 0.4)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!btnLoading) {
                      e.target.style.backgroundColor = "#004AAD";
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "0 4px 15px rgba(0, 74, 173, 0.3)";
                    }
                  }}
                >
                  {btnLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Updating...
                    </>
                  ) : (
                    "Update Profile"
                  )}
                </Button>
              </Form>
            </Card.Body>
          </Card>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateProfile;
